import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import type { LabelProps } from '@Shelly/shelly-design-system/index';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const buildLnmActionLabels = (action: ActionJob, labelList: LabelProps[]): LabelProps[] => {
	const $format = get(format);
	const [componentType, operation] = (action.params?.method || '').split('.');
	const componentId = action.params?.params?.id;

	labelList.push(
		{
			value: $format('lnm_instance_title', {
				values: { id: action.params?.id },
				default: 'LNM instance ({id})',
			}),
			icon: 'fas fa-network-wired',
			iconColor: '--color-danger',
		},
		{
			value: `${componentType} (${componentId})`,
			icon: 'far fa-microchip',
		},
	);

	if (operation?.toLowerCase() === 'toggle') {
		labelList.push({
			value: $format('schedule_action_toggle', { default: 'toggle' }),
			icon: 'fas fa-toggle-on',
		});
	} else if (operation?.toLowerCase() === 'set' && action.params?.params?.on != null) {
		const isOn = action.params.params.on === true;
		labelList.push({
			value: $format(`schedule_action_${isOn ? 'on' : 'off'}`, {
				default: isOn ? 'on' : 'off',
			}),
			icon: isOn ? 'fa-duotone fa-light fa-toggle-on' : 'fas fa-toggle-off',
			...(isOn
				? {
						iconStyle:
							'--fa-primary-color: var(--color-success); --fa-secondary-color: var(--color-success-10); --fa-secondary-opacity: 1',
					}
				: { iconColor: '--color-danger' }),
		});
	}

	return labelList;
};
